import * as React from "react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { Container } from "react-bootstrap";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { Helmet } from "react-helmet";

export default function BlogPost({ pageContext }) {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageContext.post.node.frontmatter.title}</title>
        <meta
          name="description"
          content={pageContext.post.node.frontmatter.abstract}
        />
        <meta name="robots" content="index,follow" />
      </Helmet>
      <div id="blogPostContainer">
        <Container id="blogPostHeader">
          <div>
            <AniLink
              cover
              direction="right"
              bg="#093f91"
              to="/"
              style={{ color: "white", textDecoration: "none" }}
            >
              Torna all'homepage
            </AniLink>
            <h1 style={{ marginTop: "10px" }}>
              {pageContext.post.node.frontmatter.title}
            </h1>
            <p>Pubblicato il {pageContext.post.node.frontmatter.date}</p>
            <p>In breve: {pageContext.post.node.frontmatter.abstract}</p>
          </div>
          <img
            src={"/" + pageContext.post.node.frontmatter.image}
            alt={pageContext.post.node.frontmatter.title}
          ></img>
        </Container>
      </div>
      <Container>
        <div id="blogPostBody">
          <MDXRenderer>{pageContext.post.node.body}</MDXRenderer>
        </div>
      </Container>
    </>
  );
}
